import React, { useState } from "react"
import { translate } from "../app"
import { translations } from "../translations"
import classNames from "classnames"
import { SearchOutlined } from "./icons"

interface Props extends React.HTMLAttributes<"input"> {
  onSearch?: (value: string) => void
  isRtl?: boolean
  blueButton?: boolean
}

export function Search(props: Props) {
  const [value, setValue] = useState<string>(props.defaultValue as string)

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value || ""
    setValue(value)
    if (!value) props.onSearch?.(value)
  }

  const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      props.onSearch?.(event.currentTarget.value)
    }
  }

  function onClickSearch() {
    props.onSearch?.(value)
  }

  const isRtl = props.isRtl

  return (
    <div dir={isRtl ? "rtl" : "ltr"}>
      <div className="flex h-12 md:h-14 w-full">
        {/* Input field */}
        <div className={classNames(
          "self-stretch border border-solid border-gray-300 px-3 flex-grow bg-white flex items-center",
          isRtl ? "rounded-r-md" : "rounded-l-md"
        )}>
          <input
            placeholder={translate(translations.searchForInformation)}
            aria-label={translate(translations.searchForInformation)}
            className="w-full outline-none border-0 text-base placeholder:text-gray-300 leading-none"
            type="text"
            value={value}
            onChange={onChange}
            onKeyUp={onKeyUp}
            dir={isRtl ? "rtl" : "ltr"}
          />
        </div>

        {/* Button */}
        {!props.blueButton ? (
          <button
            type="button"
            aria-label={translate(translations.search)}
            className={classNames(
              "bg-white self-stretch flex items-center justify-center border border-solid border-gray-300 w-10 cursor-pointer",
              isRtl ? "rounded-l-md" : "rounded-r-md"
            )}
            onClick={onClickSearch}
          >
            <SearchOutlined className="text-xl text-gray-400" aria-hidden="true" />
          </button>
        ) : (
          <button
            type="button"
            aria-label={translate(translations.search)}
            className={classNames(
              "bg-blue-600 text-white self-stretch flex items-center justify-center border border-solid border-blue-700 w-24 cursor-pointer",
              isRtl ? "rounded-l-md flex-row-reverse" : "rounded-r-md"
            )}
            onClick={onClickSearch}
          >
            <SearchOutlined className="text-xl text-white ml-1 mr-1" aria-hidden="true" />
            {translate(translations.search)}
          </button>
        )}
      </div>
    </div>
  )
}
